define([
    'jquery',
    'lodash/object/assign',
    'lodash/function/bindAll',
], function ($, assign, bindAll) {
    'use strict';
    var Facebook,
        facebookInitialized = false;

    Facebook = function (options) {
        assign(this, options);

        if (facebookInitialized === false) {
            this.initFacebook();
            facebookInitialized = true;
        }

        this.init();
    };

    assign(Facebook.prototype, {
        init: function () {
            bindAll(this);
            this.bindEvents();
        },

        initFacebook: function () {
            // Load external FB script
            var fbScript = document.createElement('script');
            fbScript.type = 'text/javascript';
            fbScript.src = document.location.protocol + '//connect.facebook.net/en_US/all.js';
            fbScript.async = true;
            $('head').append(fbScript);

            window.fbAsyncInit = function () {
                FB.init({appId: '412961045463060', status: true, cookie: true, xfbml: true, oauth: true});
                FB.Event.subscribe('auth.login', function (response) {
                    Facebook.prototype.login();
                });
                FB.Event.subscribe('auth.logout', function (response) {
                    Facebook.prototype.logout();
                });
                FB.getLoginStatus(function (response) {
                    if (response.session) {
                        Facebook.prototype.greet();
                    }
                });
            };
        },

        bindEvents: function () {
            this.$el.on('click', this.onShareClick);
        },

        onShareClick: function (event) {
            this.share();
        },

        login: function () {
            FB.api('/me', function (response) {
            });
        },

        logout: function () {
        },

        greet: function () {
            FB.api('/me', function (response) {
            });
        },

        share: function () {
            var share = {
                method: 'stream.share',
                u: this.link
            };

            FB.ui(share, function (response) {
            });
        }
    });

    return {
        Facebook: Facebook
    };
});



/** WEBPACK FOOTER **
 ** ./js/view/components/Facebook.js
 **/